/**
 * Compara dos versiones semánticas (p. ej. "2.2.9").
 * @returns -1 si a < b, 0 si a === b, 1 si a > b
 */
export function compareVersions(a: string, b: string): number {
    const partsA = a.split('.').map((p) => Number.parseInt(p, 10) || 0);
    const partsB = b.split('.').map((p) => Number.parseInt(p, 10) || 0);
    const maxLength = Math.max(partsA.length, partsB.length);

    for (let i = 0; i < maxLength; i++) {
        const partA = partsA[i] ?? 0;
        const partB = partsB[i] ?? 0;
        if (partA < partB) return -1;
        if (partA > partB) return 1;
    }
    return 0;
}

export function isAppVersionLatest(
    userVersion: string | null | undefined,
    recommendedVersion: string | null | undefined
): boolean | null {
    if (!userVersion || !recommendedVersion) return null;
    return compareVersions(userVersion, recommendedVersion) >= 0;
}
